import { clearToken, getToken } from '../auth/tokenStore';

const BASE = (import.meta.env.VITE_STREAM_API_BASE as string | undefined)
  || 'http://localhost:4020';

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, body: unknown, message?: string) {
    super(message || `API error ${status}`);
    this.status = status;
    this.body = body;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  // 401 = token absent/invalid. 403 = token rejected. Either way, force the
  // SPA back to the login screen by clearing the cached token.
  if (res.status === 401 || res.status === 403) {
    clearToken();
    throw new ApiError(res.status, null, 'Authentication required.');
  }

  const text = await res.text();
  const json = text ? safeJson(text) : null;
  if (!res.ok) {
    throw new ApiError(res.status, json, (json as { error?: string })?.error);
  }
  return json as T;
}

function safeJson(s: string) {
  try { return JSON.parse(s); } catch { return s; }
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
  baseUrl: BASE,
};
